import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";

const HeaderButton = (props) => {
	const { title, type, onClick, disabled, icon, tooltipTitle, id, "aria-describedby": ariaDescribedBy, ...rest } = props;
	const shared = "font-medium text-base mr-4 cursor-pointer disabled:cursor-not-allowed rounded-ctrl text-center inline-flex items-center px-4 py-1 h-[28px]";
	const primaryState = "text-text-inverse bg-primary border border-transparant border-solid hover:bg-primary-hover active:bg-primary-press disabled:bg-surface-2 disabled:text-text-3";
	const secondaryState = "border-border border border-solid bg-surface text-text hover:bg-surface-2 active:bg-surface-3 active:border-border-strong disabled:text-text-3 disabled:bg-surface-2";

	return (
		<Fragment>
			<button
				className={`${shared} ${type === "primary" ? primaryState : secondaryState}`}
				type="button"
				onClick={onClick}
				disabled={disabled}
				title={tooltipTitle}
				id={id}
				aria-describedby={ariaDescribedBy}
				{...rest}
			>
				{icon && <FontAwesomeIcon icon={icon} className="mr-2" />}
				{title}
			</button>
		</Fragment>
	);
};

export default HeaderButton;
